import { PictogramIcon } from '@speedlo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../../../app/useRoot'
import { useMapPanning } from '../../../components/Map/useMapPanning'
import { useAlertModal } from '../../../hooks/useAlertModal'
import { i18n } from '../../../i18n'

export const GeolocationButton = observer(() => {
  const { location } = useRoot()
  const panToGps = useMapPanning()

  const [alert, makeAlert] = useAlertModal()

  const attemptGeolocation = () => {
    location.log('geolocating...')
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const { latitude, longitude } = coords
        location.log(
          'geolocated at coords %s, %s (acc: %s)',
          coords.latitude,
          coords.longitude,
          coords.accuracy,
        )
        panToGps({ latitude, longitude })
      },
      err => {
        location.log('failed geolocation', err)
        makeAlert(
          i18n.t`Geolocation failed`,
          i18n.t`Your browser does not support geolocation.`,
        )
      },
      {
        enableHighAccuracy: true,
        maximumAge: 60 * 1000,
      },
    )
  }

  if (!location.isGeolocationAvailable || location.isResolving) {
    return null
  }

  return (
    <>
      {alert}
      <div className="gps" onClick={attemptGeolocation}>
        <PictogramIcon icon="gps" size={1.3} />
      </div>
    </>
  )
})

export default GeolocationButton
